
/**
 * 区域接口服务（纯接口请求）
 */
export const regionService = {
  /**
   * 获取所有区域列表
   * @returns {Promise<Response>} 后端原始响应
   */
  getRegions: () => {
    return fetch('/qhkj-agri-map-api/base/region/allList', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }
};